const VIEW_STORAGE_PREFIX = 'latthsaab:view';

function getStorageKey(contentType, contentId) {
  return `${VIEW_STORAGE_PREFIX}:${contentType}:${contentId}`;
}

export function hasTrackedView(contentType, contentId) {
  if (!contentType || !contentId || typeof window === 'undefined') {
    return false;
  }

  try {
    return window.sessionStorage.getItem(getStorageKey(contentType, contentId)) === '1';
  } catch {
    return false;
  }
}

export function markTrackedView(contentType, contentId) {
  if (!contentType || !contentId || typeof window === 'undefined') {
    return;
  }

  try {
    window.sessionStorage.setItem(getStorageKey(contentType, contentId), '1');
  } catch {
    // Ignore storage errors in restricted environments.
  }
}

export function formatEngagementCount(value) {
  const count = Number(value) || 0;

  if (count >= 1000000) {
    return `${(count / 1000000).toFixed(1).replace(/\.0$/, '')}M`;
  }

  if (count >= 1000) {
    return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}K`;
  }

  return count.toLocaleString('hi-IN');
}

export function buildAbsoluteShareUrl(url) {
  if (!url) {
    return typeof window !== 'undefined' ? window.location.href : '';
  }

  if (/^https?:\/\//i.test(url)) {
    return url;
  }

  if (typeof window === 'undefined') {
    return url;
  }

  return `${window.location.origin}${url.startsWith('/') ? url : `/${url}`}`;
}